// cspell:ignore webp msvideo
export const mimeTypeByExtension: Record<string, string> = {
  // images
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  bmp: "image/bmp",
  tiff: "image/tiff",
  tif: "image/tiff",
  // videos
  mp4: "video/mp4",
  mpeg: "video/mpeg",
  mpg: "video/mpeg",
  avi: "video/x-msvideo",
  flv: "video/x-flv",
  wmv: "video/x-ms-wmv",
  mov: "video/quicktime",
  "3gp": "video/3gpp",
  "3gpp": "video/3gpp",
  // audio
  mp3: "audio/mpeg",
  wav: "audio/wav",
  ogg: "audio/ogg",
  // documents
  pdf: "application/pdf"
};

export function getMimeType(extension: string): string {
  return (
    mimeTypeByExtension[extension.toLowerCase()] ?? "application/octet-stream"
  );
}
